module.exports = __webpack_public_path__ + "img/c92545b.png";